import React from 'react';
import { PostResponseSchema } from '@api/client';
import PostCardContent from './components/PostCardContent';
import UserInfoOverlay from '../components/UserInfoOverlay';
import PlayButtonOverlay from '../components/PlayButtonOverlay';

interface Props {
  post: PostResponseSchema;
  onVideoClick?: (post: PostResponseSchema) => void;
  onImageClick?: (post: PostResponseSchema) => void;
  wrapperStyle?: React.CSSProperties;
}

export default function PostCardRecordedPostType({
  post,
  onVideoClick,
  onImageClick,
  wrapperStyle
}: Props): React.ReactElement {
  const hasMediaOverlay = post.m3u8_url || post.photo_url;

  return (
    <>
      {/* Main content */}
      <PostCardContent
        post={post}
        onVideoClick={onVideoClick}
        onImageClick={onImageClick}
        wrapperStyle={wrapperStyle}
      />

      {/* Play button overlay for videos */}
      {post.m3u8_url && <PlayButtonOverlay />}

      {/* User info overlay for media posts */}
      {hasMediaOverlay && (
        <UserInfoOverlay
          profilePic={post.profile_pic}
          username={post.username}
          timestamp={post.timestamp}
          variant="overlay"
        />
      )}

      {/* User info overlay for text-only posts */}
      {!hasMediaOverlay && (post.message_text || post.title) && (
        <UserInfoOverlay
          profilePic={post.profile_pic}
          username={post.username}
          timestamp={post.timestamp}
          variant="overlay"
        />
      )}
    </>
  );
}
